const data = {
  MenTopwear: [
    { id: "mentopwear1", product: "Coat & Suits" },
    { id: "mentopwear2", product: "Jacket" },
    { id: "mentopwear3", product: "Kurta" },
    { id: "mentopwear4", product: "Kurta Set" },
    { id: "mentopwear5", product: "Rain Coat" },
    { id: "mentopwear6", product: "Shirt" },
    { id: "mentopwear7", product: "Sweatshirt & Sweaters" },
    { id: "mentopwear8", product: "T-Shirt" },
  ],

  MenBottomwear: [
    { id: "Menbottomwear1", product: "Casual & Formal Trousers" },
    { id: "Menbottomwear2", product: "Jeans" },
    { id: "Menbottomwear3", product: "Shorts" },
    { id: "Menbottomwear4", product: "Track & Jogger" },
    { id: "Menbottomwear5", product: "Track Pants" },
    { id: "Menbottomwear6", product: "Tracksuits" },
  ],

  MenInnerwearAndSleepwear: [
    { id: "MenInnerwearAndSleepwear1", product: "Boxer" },
    { id: "MenInnerwearAndSleepwear2", product: "Briefs & Trunks" },
    { id: "MenInnerwearAndSleepwear3", product: "Sleepwear & Loungewear" },
    { id: "MenInnerwearAndSleepwear4", product: "Thermal Wear" },
    { id: "MenInnerwearAndSleepwear5", product: "Vest" },
  ],

  WomenTopwear: [
    { id: "topwear1", product: "Abaya" },
    { id: "topwear2", product: "Dupatta & Shawl" },
    { id: "topwear3", product: "Hijabs" },
    { id: "topwear4", product: "Khimars & Jilbabs" },
    { id: "topwear5", product: "Crop Hoodies" },
    { id: "topwear6", product: "Kurtas & Suits" },
    { id: "topwear7", product: "Kurti" },
    { id: "topwear8", product: "Nosepieces" },
    { id: "topwear9", product: "Saree" },
    { id: "topwear10", product: "Shirt" },
    { id: "topwear11", product: "Sweatshirt & Sweaters" },
    { id: "topwear12", product: "Tops" },
    { id: "topwear13", product: "Tunics" },
  ],

  WomenBottomwear: [
    { id: "womenbottomwear1", product: "Cargo" },
    { id: "womenbottomwear2", product: "Jeggings" },
    { id: "womenbottomwear3", product: "Lehenga Choli" },
    { id: "womenbottomwear4", product: "Leggings" },
    { id: "womenbottomwear5", product: "Salwars" },
    { id: "womenbottomwear6", product: "Shorts - Women" },
    { id: "womenbottomwear7", product: "Skirt" },
    { id: "womenbottomwear8", product: "Trousers" },
  ],

  WomenWesternwear: [
    { id: "westernwear1", product: "Co-ords" },
    { id: "westernwear2", product: "Co-ords Set" },
    { id: "westernwear3", product: "Dresses" },
    { id: "westernwear4", product: "T-Shirts" },
    { id: "westernwear5", product: "Track Pants" },
    { id: "westernwear6", product: "Tracksuits" },
    { id: "westernwear7", product: "Playsuit & Jumpsuit" },
    { id: "westernwear8", product: "Shrugs" },
    { id: "westernwear9", product: "Waistcoat" },
    { id: "westernwear10", product: "Jackets & Coats" },
  ],

  WomenLingerieAndSleepwear: [
    { id: "lingerieandsleepwear1", product: "Bra" },
    { id: "lingerieandsleepwear2", product: "Briefs" },
    { id: "lingerieandsleepwear3", product: "Sleepwear" },
    { id: "lingerieandsleepwear4", product: "Swimmers" },
  ],

  Footwear: [
    { id: "Footwear1", product: "Flip Flops" },
    { id: "footwear2", product: "Flats" },
    { id: "footwear3", product: "Heel" },
    { id: "Footwear4", product: "Formal Shoe" },
    { id: "Footwear5", product: "Casual Shoes & Sneakers" },
    { id: "Footwear6", product: "Sandals & Floaters" },
    { id: "Footwear7", product: "Sports Shoe" },
  ],

  BeautyAndPersonalCare: [
    { id: "beautyandpersonalcare1", product: "Aroma Candles" },
    { id: "beautyandpersonalcare2", product: "Bamboo Clothing" },
    { id: "beautyandpersonalcare3", product: "Bamboo Toothbrush" },
    { id: "beautyandpersonalcare4", product: "Blush" },
    { id: "beautyandpersonalcare5", product: "Bronzer" },
    { id: "beautyandpersonalcare6", product: "Cork Yoga Mats" },
    { id: "beautyandpersonalcare7", product: "Cork Yoga Blocks" },
    { id: "beautyandpersonalcare8", product: "Cork Meditation Mat" },
    { id: "beautyandpersonalcare9", product: "Copper Bottle" },
    { id: "beautyandpersonalcare10", product: "Copper Mugs" },
    { id: "beautyandpersonalcare11", product: "Concealer" },
    { id: "beautyandpersonalcare12", product: "Essential Oils" },
    { id: "beautyandpersonalcare13", product: "Facewash" },
    { id: "beautyandpersonalcare14", product: "Face Cleanser" },
    { id: "beautyandpersonalcare15", product: "Face Mask" },
    { id: "beautyandpersonalcare16", product: "Face Scrub" },
    { id: "beautyandpersonalcare17", product: "Face Toner" },
    { id: "beautyandpersonalcare18", product: "Face Roller" },
    { id: "beautyandpersonalcare19", product: "Foundation" },
    { id: "beautyandpersonalcare20", product: "Moisturizer" },
    { id: "beautyandpersonalcare21", product: "Kansa Massager" },
    { id: "beautyandpersonalcare22", product: "Lip Balm" },
    { id: "beautyandpersonalcare23", product: "Lip Scrub" },
    { id: "beautyandpersonalcare24", product: "Lipstick" },
    { id: "beautyandpersonalcare25", product: "Mascara" },
    { id: "beautyandpersonalcare26", product: "Mist" },
    { id: "beautyandpersonalcare27", product: "Neem Combs" },
    { id: "beautyandpersonalcare28", product: "Night cream" },
    { id: "beautyandpersonalcare29", product: "Natural Loofah" },
    { id: "beautyandpersonalcare30", product: "Under eye cream" },
    { id: "beautyandpersonalcare31", product: "Serum" },
    { id: "beautyandpersonalcare32", product: "Sunscreen" },
    { id: "beautyandpersonalcare33", product: "Straws" },
    { id: "beautyandpersonalcare34", product: "Eyeliner" },
    { id: "beautyandpersonalcare35", product: "Pumice Stone" },
    { id: "beautyandpersonalcare36", product: "Primer" },
    { id: "beautyandpersonalcare37", product: "Foot cream" },
    { id: "beautyandpersonalcare38", product: "Body lotion" },
  ],

  Accessories: [
    { id: "Accessories1", product: "Braces" },
    { id: "Accessories2", product: "Caps & Hat" },
    { id: "Accessories3", product: "Cufflinks" },
    { id: "Accessories4", product: "Duffel Bag" },
    { id: "Accessories5", product: "Fragrance" },
    { id: "Accessories6", product: "Gloves" },
    { id: "Accessories7", product: "Scarves & Muffler" },
    { id: "Accessories8", product: "Trimmer" },
    { id: "Accessories9", product: "Wallet" },
    { id: "Accessories10", product: "BackPack" },
    { id: "Accessories11", product: "Belt" },
    { id: "Accessories12", product: "Body Mist" },
  ],

  Jewelleries: [
    { id: "jewel1", product: "Bracelets" },
    { id: "jewel2", product: "Earrings" },
    { id: "jewel3", product: "Necklace" },
    { id: "jewel4", product: "Pendant" },
    { id: "jewel5", product: "Ring" },
    { id: "jewel6", product: "Stud" },
    { id: "jewel7", product: "Top" },
  ],

  UnisexProducts: [
    { id: "uni1", product: "Hoodies" },
    { id: "uni3", product: "T-Shirts" },
    { id: "uni2", product: "Sweatshirts" },
  ],

  KidsProducts: [
    { id: "kids1", product: "Co-ords & Night Suit" },
    { id: "kids2", product: "Ethnic wear" },
    { id: "kids3", product: "Frocks & Dresses" },
    { id: "kids4", product: "Hoodies" },
    { id: "kids5", product: "Pants" },
    { id: "kids6", product: "Shirt" },
    { id: "kids7", product: "Shorts" },
    { id: "kids8", product: "T-Shirts" },
    { id: "kids9", product: "Track Pant" },
    { id: "kids10", product: "Blankets" },
    { id: "kids11", product: "Towels" },
    { id: "kids12", product: "Bedding Set" },
    { id: "kids13", product: "Girls Clothing set" },
    { id: "kids14", product: "Boys Clothing Set" },
    { id: "kids15", product: "Jumpsuits & Dungarees" },
  ],

  ProductTypeProducts: [
    { id: "option1", label: "Blazers and Coats" },
    { id: "option2", label: "Jacket" },
    { id: "option3", label: "Raincoats" },
    { id: "option4", label: "Sherwanis" },
    { id: "option5", label: "Shirts" },
    { id: "option6", label: "Suits" },
    { id: "option7", label: "Sweatshirts" },
    { id: "option8", label: "Sweaters" },
    { id: "option9", label: "T-shirts" },
  ],
};

export default data;
